import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDataAccessPermissionSourcesSlice } from './get';

export const coreDataSecurityDataAccessPermissionSourcesReducers = combineReducers({
	get: getCoreDataSecurityDataAccessPermissionSourcesSlice.asyncReducers
});

export const coreDataSecurityDataAccessPermissionSourcesWatchers = combineAllWatchers([
	getCoreDataSecurityDataAccessPermissionSourcesSlice.asyncWatchers
]);
